






























import { FileHeader } from "@/domain/file";
import { ShareDateTranslator } from "@/infrastructure/folder/translators";
import { Component, Mixins, Prop, Emit } from "vue-property-decorator";
import { FileSizeConverter, } from "@/utilities";

@Component
export default class FileTableSelector extends Mixins() {
  @Prop()
  files: FileHeader[];

  toFileSize(size: number): string {
    return FileSizeConverter.toString(size);
  }

  toDateString(date: Date): string {
    const dateTranslator = new ShareDateTranslator();
    return dateTranslator.toDateTimeDispString(date);
  }

  toUploadUserName(userCode: string) {
    return !!userCode ? "管理者" : "ゲスト";
  }

  @Emit()
  selectionChanged(value: FileHeader[]): void {}
}
